import request from 'lib/request';
export interface Response {
  code: number;
  msg: string;
}
export async function correct(
  data: any,
  is_verify_twitter: boolean,
  token: string
) {
  const res = await request<Response>('/project/correct', {
    method: 'post',
    data: {
      project: data,
      is_verify_twitter,
      token,
    },
  });
  return res.code;
}
